import AwardSingleCard from './AwardSingleCard';
export default AwardSingleCard;
